import { jsx as _jsx } from "react/jsx-runtime";
import ActivityLogModal from '../ActivityLogModal/ActivityLogModal';
export const activityLogModalConfig = (param)=>{
    let { relationshipId } = param;
    return {
        biName: 'activity_log_modal',
        closeOnClickOutside: true,
        closeOnEscapeKey: true,
        content: (param)=>{
            let { dismissModal } = param;
            return /*#__PURE__*/ _jsx(ActivityLogModal, {
                relationshipId: relationshipId,
                dismissModal: dismissModal
            });
        }
    };
};
